import PropTypes from "prop-types";
import React from "react";
import Icon from "./Icon";

import { makeClassNameFunctionForModule } from "../utils/cssModules";
import * as styles from "../styles/components/forms.css";

const classNames = makeClassNameFunctionForModule(styles);

class FormField extends React.PureComponent {
    static propTypes = {
        isValid: PropTypes.bool,
        message: PropTypes.string,
        children: PropTypes.node.isRequired
    };

    static defaultProps = {
        isValid: true
    };

    render() {
        return (
            <div {...classNames("fieldWrapper")}>
                <div {...classNames("field")}>{this.props.children}</div>
                <div {...classNames("message", !this.props.isValid && "error")}>
                    {this.props.message || ""}
                </div>
            </div>
        );
    }
}

export class Field extends React.PureComponent {
    static propTypes = {
        type: PropTypes.string,
        isValid: PropTypes.bool,
        message: PropTypes.string
    };

    static defaultProps = {
        type: "text",
        isValid: true
    };

    render() {
        const { isValid, message, className, ...props } = this.props;

        const actualClassName = `${className || ""} ${
            isValid ? "" : styles.error
        }`;

        return (
            <FormField isValid={isValid} message={message}>
                <input className={actualClassName} {...props} />
            </FormField>
        );
    }
}

export class PasswordField extends React.PureComponent {
    static propTypes = {
        isValid: PropTypes.bool,
        message: PropTypes.string
    };

    static defaultProps = {
        isValid: true
    };

    constructor(props) {
        super(props);
        this.state = { isShowing: false };
        this.onToggle = this.onToggle.bind(this);
    }

    onToggle() {
        this.setState(state => {
            return { isShowing: !state.isShowing };
        });
    }

    render() {
        const { isValid, message, className, ...props } = this.props;
        const type = this.state.isShowing ? "text" : "password";
        const icon = this.state.isShowing ? "eye" : "eye-slash";

        const actualClassName = `${className || ""} ${
            isValid ? "" : styles.error
        }`;

        return (
            <FormField isValid={isValid} message={message}>
                <input type={type} className={actualClassName} {...props} />
                <button
                    type="button"
                    className={styles.passwordToggle}
                    onClick={this.onToggle}
                >
                    <Icon icon={icon} />
                </button>
            </FormField>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/forms.js